package com.milta.feature.legal.domain.usecase

import com.milta.feature.legal.domain.entity.LegalDocument
import com.milta.feature.legal.domain.entity.LegalDocumentType
import com.milta.feature.legal.domain.repository.LegalDocumentRepository

class GetLegalDocumentUseCase(private val repository: LegalDocumentRepository) {
    suspend operator fun invoke(type: LegalDocumentType, lang: String): LegalDocument =
        repository.getLegalDocument(type, lang)
}
